import styled from 'styled-components';
import { Button } from 'atoms';

export const ButtonWrapper = styled(Button)`
	color: #091744;
	background-color: transparent;
	align-self: center;
	display: flex;
	justify-content: center;
	align-items: center;
	&:hover {
		text-decoration: none;
		background-color: rgba(9, 23, 68, 0.04);
	}
	svg {
		margin-right: 8px;
	}
`;
